function PivotRowDimension(props) {
    return null;
}
PivotRowDimension.symbol = 'PivotRowDimension';

export { PivotRowDimension as default };
